import { AMEND_COMPLETE } from 'redux/modules/amend-order/actions/types';

export const amendActionComplete = () => ({
  type: AMEND_COMPLETE,
});
